import { __exports as l } from "../../../../../../../../../_virtual/index2.js";
import "./email-template.js";
import "./default.js";
import "./inbox-composer.js";
import "./html-block.js";
import { __exports as _ } from "../../../../../../../../../_virtual/html-block.js";
import { __exports as s } from "../../../../../../../../../_virtual/inbox-composer.js";
import { __exports as f } from "../../../../../../../../../_virtual/email-template.js";
import { __exports as p } from "../../../../../../../../../_virtual/default.js";
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = n;
  var r = f, a = p, i = s, m = _, o = {
    default: a.DEFAULT_CONFIG,
    email: r.EMAIL_TEMPLATE_CONFIG,
    inboxComposer: i.INBOX_COMPOSER_CONFIG,
    htmlBlock: m.HTML_BLOCK_CONFIG
  };
  function n() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default";
    if (!o[t])
      throw new Error("@intercom/intercom-sanitizer: You passed an invalid configuration, `".concat(t, "`,  to `sanitizeHtml`. The only valid configurations are: `").concat(Object.keys(o).join(", "), "`"));
    return o[t];
  }
})(l);
